import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';

const Experiences = (props) => {
  const { reservationTypes } = props;
  return (
    <Field
      name="reservationTypeId"
      component={SelectField}
      optionArray={reservationTypeOptionArray(reservationTypes)}
      className="c7-form-label__reservation-experiences"
      label="Experiences"
      required
    />
  );
};

const reservationTypeOptionArray = (reservationTypes) => {
  const array = [];
  array.push({ option: 'All Experiences', value: '' });
  const reservationTypeIds = Object.keys(reservationTypes.data);
  reservationTypeIds.forEach((id) => {
    array.push({ option: reservationTypes.data[id].title, value: id });
  });
  return array;
};

export default Experiences;
